import React from 'react'
import './Hero.css'
function Hero(props) {
    return (
        <div className="heroWrapper">

            <div className="hero">
                <div className="heroMain">
                    <h1 className="heroTitle">
                        {props.title}
                    </h1>
                    <h1 className="heroSubTitle">
                        {props.title2}
                    </h1>
                </div>
                <div className="heroSub">
                    <p className="heroSubContent">
                        {props.sub}
                    </p>
                </div>
            </div>

        </div>
    )
}

export default Hero
